import React, { useMemo } from 'react';

import getEnabledItems from '@lyearn/core/utils/array/getEnabledItems';
import { useTranslation } from '@lyearn/i18n';
import { CopyIcon, Delete, MoveOutline } from '@lyearn/icons';
import { ActionMenu, ActionMenuProps } from '@lyearn/molecules';
import { Touchable } from '@lyearn/ui';
import { DatabaseFormEditorActionEnum } from '@/modules/corporate/modules/database/views/FormView/components/DatabaseFormEditor/types';

import { FieldActionProps } from './types';

const OVERRIDES: ActionMenuProps['overrides'] = {
  PopoverButton: {
    classes: {
      root: 'absolute w-24 h-24 mt-16 -ms-32',
      open: 'opacity-100',
      closed: 'opacity-0 group-hover:opacity-100',
    },
  },
  PopoverContent: {
    position: 'left-start',
  },
};

const FieldAction: React.FC<FieldActionProps> = (props) => {
  const { allowPartialUpdates, getDragHandleProps, isQuestion, onAction } = props;
  const { t } = useTranslation();

  const items = useMemo(
    () =>
      getEnabledItems([
        {
          id: DatabaseFormEditorActionEnum.DuplicateField,
          label: t('Common:Actions.Duplicate'),
          EndIcon: CopyIcon,
          enabled: !isQuestion,
        },
        {
          id: DatabaseFormEditorActionEnum.RemoveField,
          label: t('Common:Actions.Delete'),
          EndIcon: Delete,
          appearance: 'danger',
          enabled: !allowPartialUpdates,
        },
        {
          id: DatabaseFormEditorActionEnum.HideField,
          label: t('Common:Actions.Delete'),
          EndIcon: Delete,
          appearance: 'danger',
          enabled: !!allowPartialUpdates,
        },
      ]) as ActionMenuProps['items'],
    [allowPartialUpdates, isQuestion, t],
  );

  return (
    <ActionMenu items={items} overrides={OVERRIDES} onAction={onAction}>
      <Touchable>
        <MoveOutline
          className="h-24 w-24 text-icon-placeholder hover:text-icon-active"
          {...getDragHandleProps()}
        />
      </Touchable>
    </ActionMenu>
  );
};

export default FieldAction;
